import { render, staticRenderFns } from "./5.vue?vue&type=template&id=5cda59e0&scoped=true"
import script from "./5.vue?vue&type=script&lang=js"
export * from "./5.vue?vue&type=script&lang=js"
import style0 from "./5.vue?vue&type=style&index=0&id=5cda59e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cda59e0",
  null
  
)

export default component.exports